import xlogo_cn from  '../assets/logos/xhorse_cn.png';
import xlogo_en from  '../assets/logos/xhorse_en.png';
import cn from '../assets/images/flags/China.png';
import en from '../assets/images/flags/United States.png';
import German from '../assets/images/flags/Germany.png';
import Japan from '../assets/images/flags/Japan.png';
import Sk from '../assets/images/flags/South Korea.png';
import Fran from '../assets/images/flags/France.png';
import Russia from '../assets/images/flags/Russia.png';
import Spain from '../assets/images/flags/Spain.png';
import Portugal from '../assets/images/flags/Portugal.png';
import Italy from '../assets/images/flags/Italy.png';
import VietNam from '../assets/images/flags/Vietnam.png';
import Arab from '../assets/images/flags/Saudi Arabia.png';


export let init = function (userarea, _this) {
    
    switch (parseInt(userarea)) {
        case 0:
            _this.$i18n.locale = 'cn';
            _this.src = xlogo_cn;
            _this.langFlag = cn;
            break;
    /*    case 1:
     _this.$i18n.locale = 'en';
     _this.src = xlogo_en;
     _this.langFlag = en;
     break;
     case 49:
     _this.$i18n.locale = 'dy';
     _this.src = xlogo_en;
     _this.langFlag = German;
     break;
     case 81:
     _this.$i18n.locale = 'ry';
     _this.src = xlogo_en;
     _this.langFlag = Japan;
     break;
     case 82:
     _this.$i18n.locale = 'hy';
     _this.src = xlogo_cn;
     _this.langFlag = Sk;
     break;
     case 33:
     _this.$i18n.locale = 'fy';
     _this.src = xlogo_cn;
     _this.langFlag = Fran;
     break;
     case 375:
     _this.$i18n.locale = 'ey';
     _this.src = xlogo_cn;
     _this.langFlag = Russia;
     break;
     case 34:
     _this.$i18n.locale = 'xby';
     _this.src = xlogo_cn;
     _this.langFlag = Spain;
     break;
     case 351:
     _this.$i18n.locale = 'ptyy';
     _this.src = xlogo_cn;
     _this.langFlag = Portugal;
     break;
     case 39:
     _this.$i18n.locale = 'ydly';
     _this.src = xlogo_cn;
     _this.langFlag = Italy;
     break;
     case 84:
     _this.$i18n.locale = 'yny';
     _this.src = xlogo_cn;
     _this.langFlag = VietNam;
     break;
     case 971:
     _this.$i18n.locale = 'alby';
     _this.src = xlogo_cn;
     _this.langFlag = Arab;
     break;*/
        case 1:
            _this.$i18n.locale = 'en';
            _this.src = xlogo_en;
            _this.langFlag = en;
            break;
    }
};


// WEBPACK FOOTER //
// ./src/config/index.js